// import React from "react";
// import {
//   BottomNavigation,
//   BottomNavigationAction,
//   Paper
// } from "@mui/material";

// import HomeIcon from "@mui/icons-material/Home";
// import SearchIcon from "@mui/icons-material/Search";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import PersonIcon from "@mui/icons-material/Person";
// import LoginIcon from "@mui/icons-material/Login";
// import CallIcon from "@mui/icons-material/Call";

// import { useNavigate, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// const MobileBottomNav = () => {
//   const isAuthenticated = useSelector(
//     (state) => state.user.isAuthenticated
//   );

//   const navigate = useNavigate();
//   const location = useLocation();

//   const go = (path) => {
//     if (path === "/") {
//       window.location.href = "/";
//     } else {
//       navigate(path);
//     }
//   };

//   // 🔥 active style helper
//   const actionStyle = (path) => ({
//     color: location.pathname === path ? "#1976d2" : "#757575",
//     "& .MuiBottomNavigationAction-label": {
//       color: location.pathname === path ? "#1976d2" : "#757575",
//       fontWeight: location.pathname === path ? 600 : 400
//     }
//   });

//   return (
//     <Paper
//       elevation={10}
//       sx={{
//         position: "fixed",
//         bottom: 0,
//         left: 0,
//         right: 0,
//         zIndex: 1300,
//         display: { xs: "block", md: "none" }
//       }}
//     >
//       <BottomNavigation
//         showLabels
//         sx={{
//           "& .MuiBottomNavigationAction-label": {
//             opacity: 1,
//             transform: "none",
//             fontSize: "12px"
//           }
//         }}
//       >
//         <BottomNavigationAction
//           label="Home"
//           icon={<HomeIcon />}
//           sx={actionStyle("/")}
//           onClick={() => go("/")}
//         />

//         <BottomNavigationAction
//           label="Search"
//           icon={<SearchIcon />}
//           sx={actionStyle("/search")}
//           onClick={() => go("/search")}
//         />

//         {!isAuthenticated && (
//           <>
//             <BottomNavigationAction
//               label="Contact"
//               icon={<CallIcon />}
//               sx={{
//                 ...actionStyle("/contact"),
//                 paddingBottom:"15px"
//               }}
//               onClick={() => go("/contact")}
//             />
//             <BottomNavigationAction
//               label="Sign In"
//               icon={<LoginIcon />}
//                sx={{
//                 ...actionStyle("/sign-up/login"),
//                 paddingBottom:"15px"
//               }}

//               onClick={() => go("/sign-up/login")}
//             />
//           </>
//         )}

//         {isAuthenticated && (
//           <>
//             <BottomNavigationAction
//               label="Saved"
//               icon={<FavoriteIcon />}
//               sx={{...actionStyle("/favorites"),
//                 paddingBottom:"15px"
//               }}
//               onClick={() => go("/favorites")}
//             />
//             <BottomNavigationAction
//               label="Profile"
//               icon={<PersonIcon />}
//               sx={{...actionStyle("/myprofile"),
//                 paddingBottom:"15px"
//               }}
//               onClick={() => go("/myprofile")}
//             />
//           </>
//         )}
//       </BottomNavigation>
//     </Paper>
//   );
// };

// export default MobileBottomNav;



import React, { useState } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper
} from "@mui/material";

import { HiHome, HiMagnifyingGlass, HiHeart, HiUser } from "react-icons/hi2";
import { RiPhoneFill, RiLoginBoxLine } from "react-icons/ri";

import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import LoginModal from "../components/common/LoginModal";

const MobileBottomNav = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const [openLoginModal, setOpenLoginModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const go = (path) => {
    navigate(path);
  };

  const iconStyle = (path) => ({
    fontSize: 24,
    color: location.pathname === path ? "#E91E8C" : "#9e9e9e",
    transition: "transform 0.2s ease, color 0.2s ease",
    transform: location.pathname === path ? "scale(1.25)" : "scale(1)",
    display: "inline-flex",
  });

  return (
    <Paper
      elevation={12}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        display: { xs: "block", md: "none" },
        backgroundColor: "#fff",
        borderTop: "1px solid #e0e0e0",
        transform: "translateZ(0)",
        paddingBottom: "env(safe-area-inset-bottom)",
        minHeight: 64,
      }}
    >
      <BottomNavigation
        value={location.pathname}
        showLabels
        sx={{
          "& .MuiBottomNavigationAction-label": {
            fontSize: "11px",
            opacity: 1,
            fontWeight: 500,
          },
          "& .Mui-selected": {
            color: "#E91E8C",
          },
          "& .MuiBottomNavigationAction-root": {
            color: "#9e9e9e",
            minWidth: 0,
            padding: "6px 0",
          },
          "& .MuiBottomNavigationAction-root.Mui-selected": {
            color: "#E91E8C",
          },
        }}
      >
        <BottomNavigationAction
          value="/"
          label="Home"
          icon={<span style={iconStyle("/")}><HiHome size={30} /></span>}
          onClick={() => go("/")}
        />

        <BottomNavigationAction
          value="/search"
          label="Search"
          icon={<span style={iconStyle("/search")}><HiMagnifyingGlass size={30} /></span>}
          onClick={() => go("/search")}
        />

        {!isAuthenticated ? (
          <>
            <BottomNavigationAction
              value="/contact"
              label="Contact"
              icon={<span style={iconStyle("/contact")}><RiPhoneFill size={30} /></span>}
              onClick={() => go("/contact")}
            />
            <BottomNavigationAction
              value="sign-in"
              label="Sign In"
              icon={<span style={iconStyle("sign-in")}><RiLoginBoxLine size={30} /></span>}
              onClick={() => setOpenLoginModal(true)}
            />
          </>
        ) : (
          <>
            <BottomNavigationAction
              value="/favorites"
              label="Saved"
              icon={<span style={iconStyle("/favorites")}><HiHeart size={30} /></span>}
              onClick={() => go("/favorites")}
            />
            <BottomNavigationAction
              value="/myprofile"
              label="Profile"
              icon={<span style={iconStyle("/myprofile")}><HiUser size={30} /></span>}
              onClick={() => go("/myprofile")}
            />
          </>
        )}
      </BottomNavigation>
      {openLoginModal && (
        <LoginModal onClose={() => setOpenLoginModal(false)} />
      )}
    </Paper>
  );
};

export default MobileBottomNav;